import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Add = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.8 13.8"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <path d="M8.05 5.8h4.625a1.125 1.125 0 1 1 0 2.25H8.05v4.625a1.125 1.125 0 1 1-2.25 0V8.05H1.125a1.125 1.125 0 0 1 0-2.25H5.8V1.125a1.125 1.125 0 0 1 2.25 0z" />
    </svg>
  );
};

Add.displayName = 'Add';
